import { useTranslation } from 'react-i18next';
import { useEffect, useMemo, useRef } from 'react';
import { useToast } from '../../../app/contexts/toast/toast.context';
import { useConnection } from '../../../app/contexts/connection/connection-context';

function ConnectionError() {
    const { t } = useTranslation();
    const { setToast } = useToast();
    const { error: poolError } = useConnection();

    const hasShownErrorRef = useRef<boolean>(false);

    const error = useMemo(() => poolError, [poolError]);

    useEffect(() => {
        if (error && !hasShownErrorRef.current) {
            setToast('warning', t('Updates'), error);
            hasShownErrorRef.current = true;
        }
    }, [t, setToast, error]);

    return <span style={{ visibility: 'hidden' }}>WS Connection Error!</span>;
}

export default ConnectionError;
